// extracted by mini-css-extract-plugin
export var messageSideLeft = "_tr-1";
export var stateContainer = "_tr-0";